import { useState, useContext, useEffect } from "react";
import { verificaDni } from "../../../context/Actions/verificaDni/verificaDni";
import { logoutVerificaDni } from "../../../context/Actions/verificaDni/logoutVerificaDni";
import { PortalContext } from "../../../context/Provider";
import { showModal, hideModal } from "../../../context/Actions/modal/modal";
import {
  setUsuario,
  setListError,
} from "../../../context/Actions/registro/registro";
import isDniValido from "../../../../global/utils/checkDniValido";
import {
  filtrarPorRegex,
  regexSoloDigitos,
} from "global/utils/inputValidators";
import {
  logoutPacienteDefault,
  wsGetCambioClave,
} from "../../../context/Actions/paciente/paciente";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import Mensaje from "../../Genericos/Mensaje/Mensaje";
import "./RegistroIngresoDni.css";
import {
  hideSegundoModal,
  showSegundoModal,
} from "../../../context/Actions/segundoModal/segundoModal";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";
import { localidad } from "_+_Portal/context/Actions/localidad/localidad";
import { obraSocial } from "_+_Portal/context/Actions/obraSocial/obraSocial";
import { IonSpinner } from "@ionic/react";

const RegistroIngresoDni = ({
  headerStr,
  name,
  inputType,
  errorStr,
  placeholderText,
  className,
  maxLength,
  dissmiss,
  danger,
  titulo,
  isRequired,
  pattern,
  inputMode,
}) => {
  const {
    modalDispatch,
    verificaDniState,
    verificaDniDispatch,
    registroState,
    registroDispatch,
    pacienteDispatch,
    segundoModalDispatch,
    localidadDispatch,
    obraSocialDispatch,
  } = useContext(PortalContext);

  // Toaster Global
  const { toasterDispatch } = useContext(GlobalContext);

  const [dni, SetDni] = useState("");

  const preventEletter = (e) => {
    if (
      e.key === "e" ||
      e.key === "E" ||
      e.key === "+" ||
      e.key === "." ||
      e.key === "," ||
      e.key === "-"
    ) {
      e.preventDefault();
    }
    if (e.key === "Enter") {
      if (isDniValido(e)) {
        verificaDni(dni, nextStepRegistro)(verificaDniDispatch);
      }
    }
  };

  const onRegistroTxtChange = (e) => {
    const valorNuevo = e.target.value;

    // Filtro genérico por regex: si lo que pegaron/escribieron no cumple,
    // no actualizo el estado ni el store. El input (controlado) se queda
    // con el último valor válido (y forzamos el DOM a ese valor).
    const { esValido, valorSanitizado } = filtrarPorRegex(
      valorNuevo,
      regexSoloDigitos
    );

    if (!esValido) {
      // Revertimos visualmente al último DNI válido
      e.target.value = dni;

      // Si el DNI actual ya es válido (7-9 dígitos), solo muestro toaster sin marcar error
      if (dni && dni.length >= 7 && dni.length <= 9) {
        showToaster(
          {
            texto: "Solo se permiten números",
            tipo: "info",
          },
          "centroArriba"
        )(toasterDispatch);
      } else {
        // Solo marco error si el campo está vacío o incompleto
        let errx = { ...registroState.registro.listError };
        errx.nro_documento = true;
        setListError(errx)(registroDispatch);
      }
      return;
    }

    let errx = { ...registroState.registro.listError };
    errx.nro_documento = !isDniValido(e);
    setListError(errx)(registroDispatch);

    let usuario = { ...registroState.registro.usuario };
    usuario.nro_documento = valorSanitizado;
    SetDni(valorSanitizado);
    setUsuario(usuario)(registroDispatch);
  };

  const verificandoDni = () => {
    if (
      !registroState.registro.listError.nro_documento &&
      registroState.registro.usuario.nro_documento !== ""
    ) {
      verificaDni(dni, nextStepRegistro)(verificaDniDispatch);
    } else {
      showToaster(
        {
          texto: "Por favor, ingrese un DNI válido.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  const cleanDni = () => {
    logoutVerificaDni()(verificaDniDispatch);
    setTimeout(() => {
      hideModal()(modalDispatch);
      hideSegundoModal()(segundoModalDispatch);
    }, 250);
  };

  const showSolicitarCodigo = () => {
    let dni = registroState.registro.usuario.nro_documento;
    wsGetCambioClave(dni, changePaso)(pacienteDispatch);
  };

  const changePaso = (isCorrect, data) => {
    if (isCorrect) {
      if (data !== null && data !== undefined) {
        hideModal()(modalDispatch);
        showToaster(
          {
            texto: "Enviamos el código a su casilla de Email.",
            tipo: "success",
          },
          "centroArriba"
        )(toasterDispatch);
        showModal(
          "Auth/CambioPassword/CambioPasswordPaso2",
          {
            dissmiss: cleanDni,
          },
          {},
          "centro",
          true
        )(modalDispatch);
      }
    } else {
      // Manejo de error normalizado con compatibilidad legacy
      if (data !== null && data !== undefined && data !== false) {
        // Usamos userMessage si está disponible, sino data (legacy)
        const mensajeError =
          data.userMessage ||
          data.data ||
          "Su código no pudo ser verificado, contáctese con el centro de atención al paciente";

        showToaster(
          {
            texto: mensajeError,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        hideModal()(modalDispatch);
        logoutPacienteDefault()(pacienteDispatch);
      }
    }
  };

  const segundoDissmiss = () => {
    hideSegundoModal()(segundoModalDispatch);
  };

  const forgottenPasword = () => {
    logoutVerificaDni()(verificaDniDispatch);
    hideSegundoModal()(segundoModalDispatch);
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "Solicitud correcta",
        texto:
          "Le enviaremos un mail a su casilla de correo con un token de seguridad que deberá ingresar para completar el proceso. De lo contrario, puede volver al Login para Iniciar Sesión.",
        dissmiss: cleanDni,
      },
      [
        {
          text: "Volver al login",
          clase: "btn-Mensaje b-latex30 rb16m c-latex30",
          accion: cleanDni,
        },
        {
          text: "Solicitar Token",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: showSolicitarCodigo,
        },
      ],
      "centro",
      true
    )(modalDispatch);
  };

  const nextStepRegistro = (isCorrect, data) => {
    if (isCorrect) {
      if (data.registrado) {
        //El Paciente se encuentra dado de alta en la base de datos
        hideModal()(modalDispatch);
        showSegundoModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: "Verifica DNI",
            textoNegrita: "Su DNI ya existe en nuestra Base de Datos",
            texto:
              "Usted ya posee un Dni registrado. Presione volver al login para Ingresar al Portal o puede Recuperar su Contraseña",
            dissmiss: cleanDni,
            danger: true,
          },
          [
            {
              text: "Volver al login",
              clase: "btn-Mensaje b-latex30 rb16m c-latex30",
              accion: cleanDni,
            },
            {
              text: "Recuperar Contraseña",
              clase: "btn-Mensaje-1 rb16m bgc-primary c-white",
              accion: forgottenPasword,
            },
          ],
          "centro"
        )(segundoModalDispatch);
      } else {
        //No encuentro dni del paciente. Procedo al registro
        hideModal()(modalDispatch);
        localidad()(localidadDispatch);
        obraSocial()(obraSocialDispatch);
        showSegundoModal(
          "Auth/Registracion/Registracion",
          {
            dissmiss: segundoDissmiss,
          },
          null,
          "centroDerecha",
          true
        )(segundoModalDispatch);
      }
    } else {
      showToaster(
        {
          texto: data?.data ? data?.data : "Error al contactar el server.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  // useEffect(() => {
  //   if (
  //     verificaDniState.verificaDni.error !== null &&
  //     verificaDniState.verificaDni.error !== undefined &&
  //     verificaDniState.verificaDni.error.data === "" &&
  //     verificaDniState.verificaDni.error.status === 404
  //   ) {
  //     //No encuentro dni del paciente. Procedo al registro
  //     hideModal()(modalDispatch);
  //     showSegundoModal(
  //       "Auth/Registracion/Registracion",
  //       {
  //         dissmiss: segundoDissmiss,
  //       },
  //       null,
  //       "centroDerecha",
  //       true
  //     )(segundoModalDispatch);
  //     //cambiar segundo mal por setTimeOut (para manejar un modal dentro de un modal)
  //   } else if (
  //     verificaDniState.verificaDni.error !== null &&
  //     verificaDniState.verificaDni.error !== undefined &&
  //     verificaDniState.verificaDni.error.data !== "" &&
  //     verificaDniState.verificaDni.error.status === 400
  //   ) {
  //     //El Paciente se encuentra dado de alta en la base de datos
  //     showToaster(
  //       {
  //         texto: verificaDniState.verificaDni.error.data,
  //         tipo: "danger",
  //       },
  //       "centroArriba"
  //     )(toasterDispatch);
  //     if (verificaDniState.verificaDni.error.data) {
  //       dissmiss();
  //     }
  //   } else if (
  //     verificaDniState.verificaDni.data !== null &&
  //     verificaDniState.verificaDni.data !== undefined &&
  //     verificaDniState.verificaDni.data.codigo >= 1
  //   ) {
  //     //El Paciente se encuentra dado de alta en la base de datos
  //     hideModal()(modalDispatch);
  //     showSegundoModal(
  //       "Genericos/Mensaje/Mensaje",
  //       {
  //         titulo: "Verifica DNI",
  //         textoNegrita: "Su DNI ya existe en nuestra Base de Datos",
  //         texto:
  //           "Usted ya posee un Dni registrado. Presione volver al login para Ingresar al Portal o puede Recuperar su Contraseña",
  //         dissmiss: cleanDni,
  //         danger: true,
  //       },
  //       [
  //         {
  //           text: "Volver al login",
  //           clase: "btn-Mensaje b-latex30 rb16m c-latex30",
  //           accion: cleanDni,
  //         },
  //         {
  //           text: "Recuperar Contraseña",
  //           clase: "btn-Mensaje-1 rb16m bgc-primary c-white",
  //           accion: forgottenPasword,
  //         },
  //       ],
  //       "centro"
  //     )(segundoModalDispatch);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [verificaDniState]);

  useEffect(() => {
    document.getElementsByName("txtVerificaDni")[0].focus();
  }, []);

  return (
    <>
      <div className="ptur-registro-ingreso-dni">
        <Mensaje titulo={titulo} dissmiss={dissmiss} danger={danger} />
        <div className="ptur-registro-ingreso-dni-input">
          <InputV1
            name={name}
            inputType="text"
            inputMode="numeric"
            className={className}
            onChange={onRegistroTxtChange}
            onKeyPress={preventEletter}
            headerStr={headerStr}
            errorStr={errorStr}
            placeholderText={placeholderText}
            maxLength={maxLength}
            checkError={registroState.registro.listError.nro_documento}
            isRequired={isRequired}
            pattern="[0-9]*"
          />
        </div>
        <div
          className="ptur-btn-divBox"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            className="btn b-latex30 rb18m c-latex30"
            onClick={dissmiss}
            disabled={verificaDniState.verificaDni.loading}
          >
            Volver
          </button>
          <button
            className="btn rb18m bgc-primary c-white"
            onClick={verificandoDni}
            disabled={verificaDniState.verificaDni.loading}
            style={{
              minHeight: "40px",
              ...(verificaDniState.verificaDni.loading && {
                paddingTop: 7,
                paddingBottom: 6,
              }),
            }}
          >
            {verificaDniState.verificaDni.loading ? (
              <IonSpinner name="lines-small" />
            ) : (
              "Verificar"
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default RegistroIngresoDni;
